// utils/notificationUtils.js

/**
 * Request permission for browser notifications
 */
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications.');
    return 'unsupported';
  }

  let permission = Notification.permission;

  if (permission === 'default') {
    permission = await Notification.requestPermission();
  }

  console.log('Notification permission:', permission);
  return permission;
};

/**
 * Show a system notification
 * @param {string} title - Notification title
 * @param {string} body - Notification body text
 * @param {object} options - Additional notification options
 */
export const showSystemNotification = (title, body, options = {}) => {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications.');
    return;
  }

  if (Notification.permission === 'granted') {
    new Notification(title, {
      body,
      icon: '/logo192.png', // React default logo
      badge: '/logo192.png',
      ...options,
    });
  } else if (Notification.permission === 'default') {
    // Request permission if not yet decided
    requestNotificationPermission().then((permission) => {
      if (permission === 'granted') {
        new Notification(title, {
          body,
          icon: '/logo192.png',
          badge: '/logo192.png',
          ...options,
        });
      }
    });
  } else {
    console.warn('Notifications are blocked by the user.');
  }
};

/**
 * Check if notifications are supported and enabled
 */
export const isNotificationSupported = () => {
  return 'Notification' in window;
};

/**
 * Check if notifications are granted
 */
export const isNotificationGranted = () => {
  return isNotificationSupported() && Notification.permission === 'granted';
};
